import { NextSeo } from 'next-seo'
import { useMemo, type FC } from 'react'
import { MainLayout } from '@/components/layout/MainLayout'
import { SearchTerms } from '@/components/term/SearchTerms'
import { useTermAPICall } from '@/lib/hooks'
import type { TermItem } from 'models/termItem'
import config from '../../../../config/config'

export const ListPage: FC = () => {
  const getTermQuery = useTermAPICall('term')
  const termData = useMemo(() => {
    if (!getTermQuery.data?.data) {
      return null
    }
    return getTermQuery.data?.data.map((item: TermItem) => {
      return {
        ...item,
        squareImage: `${config.getPublicImageDomain()}${item.squareImage}`,
        transparentImage: item.transparentImage
          ? `${config.getPublicImageDomain()}${item.transparentImage}`
          : '',
      }
    })
  }, [getTermQuery.data])

  return (
    <>
      <NextSeo
        title="Discover FDI Glossary"
        description="Search our glossary covers over 240 FDI terms, from financial concepts to policy tools and trade agreements, offering a broad understanding of FDI."
        twitter={{
          cardType: 'summary_large_image',
        }}
        openGraph={{
          title: 'Discover FDI Glossary',
          description:
            'Search our glossary covers over 240 FDI terms, from financial concepts to policy tools and trade agreements, offering a broad understanding of FDI.',
          images: [
            {
              url: `https://fdiglossary.invest.gov.tr/images/home-page-background.png`,
              width: 1024,
              height: 1024,
              type: 'image/jpeg',
            },
          ],
        }}
      />
      <MainLayout>
        <section className="hero-section">
          <div className="w-layout-blockcontainer w-container container">
            <div className="hero-content-div">
              <div className="heading-set">
                <div className="heading-set-2">
                  <div className="tagline-heading">GLOSSARY</div>
                  <div className="heading-set-3">
                    <h1 className="heading-1">Discover FDI Glossary</h1>
                    <div className="description">
                      Search our glossary covers over 240 FDI terms, from financial concepts to
                      policy tools and trade agreements, offering a broad understanding of FDI.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {termData && <SearchTerms termData={termData} />}
      </MainLayout>
    </>
  )
}
